module.exports = __webpack_public_path__ + "img/default.a642153e.jpg";